// Masa aktif langganan aset. Sengaja NOL IMPORT ber-alias biar bisa diuji node.
import moment from 'moment';

// massSubscriptionExpiredAt itu tanggal KALENDER, bukan instan — bagian jamnya
// (kalau ada) diabaikan, dan langganan berlaku sampai akhir hari itu.
export function subscriptionEndsAt(dateStr) {
  const day = moment(String(dateStr || '').slice(0, 10), 'YYYY-MM-DD', true);
  return day.isValid() ? day.endOf('day') : null;
}

// Kedaluwarsa cuma setelah hari terakhirnya lewat. Tanggal kosong = gak diset,
// dan yang gak diset bukan berarti kedaluwarsa.
export function isSubscriptionExpired(dateStr, now = undefined) {
  const end = subscriptionEndsAt(dateStr);
  if (!end) return false;
  return end.isBefore(now === undefined ? moment() : moment(now));
}

// Sisa hari penuh. 0 = habis hari ini tapi masih aktif; negatif = sudah lewat.
export function daysUntilExpiry(dateStr, now = undefined) {
  const end = subscriptionEndsAt(dateStr);
  if (!end) return null;
  const today = (now === undefined ? moment() : moment(now)).startOf('day');
  return end.clone().startOf('day').diff(today, 'days');
}
